import { Model } from '../../infra/model'
import { observable, makeObservable } from 'mobx'
import { Id } from '../../types/definitions'
import { DateZero, maybeParseDate } from '../../utils/date-util'

export interface JobTicketProps {
  id: string
  job_id: string
  status_message: string | null
  date_updated: string
}

/**
 * A ticket for a job.
 */
export class JobTicket extends Model<JobTicketProps, JobTicket> {
  id = Id.none
  jobId = Id.none
  statusMessage = ''
  lastUpdated = DateZero()

  constructor() {
    super()
    makeObservable(this, {
      statusMessage: observable,
      lastUpdated: observable,
    })
  }

  parse(attrs: Partial<JobTicketProps>): Partial<JobTicket> {
    return {
      id: attrs.id,
      jobId: attrs.job_id,
      statusMessage: attrs.status_message === null ? '' : attrs.status_message,
      lastUpdated: maybeParseDate(attrs.date_updated),
    }
  }
}
